import { InlineLoader, Translation } from '@jsverse/transloco';

// based on source: https://github.com/NetanelBasal/transloco-with-nx-libs/blob/master/scoped-translations.ts

export const availableLangs = ['en', 'es'];

export const scopeLoader = (
  importer: (lang: string, root: string) => Promise<Translation>,
  root = 'i18n'
) => {
  return availableLangs.reduce((acc: InlineLoader, lang) => {
    acc[lang] = () => importer(lang, root);
    return acc;
  }, {});
};
